import React, { useEffect, useRef, useState } from "react";
import {
  Badge,
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Spin,
  Table,
  Tooltip,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import "react-datepicker/dist/react-datepicker.css";
import "react-responsive-modal/styles.css";
import "../theme/ReporteCierreDia.css";
import "../theme/Pagination.css";
import Highlighter from "react-highlight-words";
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  RedoOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { UseAdmin, UseUser } from "../hooks";
import { useNavigate } from "react-router-dom";
import { GetFetchPersonal } from "../Api/Administracion/GetFetchPersonal";
import { UpdateFetchPersonal } from "../Api/Administracion/UpdateFetchPersonal";
import dayjs from "dayjs";
import { FormRecurso } from "./FormRecurso";

const { RangePicker } = DatePicker;

const EstadoSolicitud = Object.freeze({
  PENDIENTE_APROBACION: "1",
  APROBADO: "2",
  RECHAZADO: "3",
  EN_PRESTAMO: "4",
  CONCLUIDO: "5",
  CANCELADO: "6",
});

export const TableMisSolicitudes = () => {
  const { employeeId } = UseUser();
  const { branchFiSucursalId } = UseAdmin();
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [solicitudes, setSolicitudes] = useState([]);
  const [solicitudesTodas, setSolicitudesTodas] = useState([]);
  const [searchedColumn, setSearchedColumn] = useState("");
  const [selectedSolicitud, setSelectedSolicitud] = useState(null);
  const [empleadoAsignado, setEmpleadoAsignado] = useState(null);
  const searchInput = useRef(null);
  const navigate = useNavigate();
  const [cancelAndDeclineForm] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalOkVisible, setIsModalOkVisible] = useState(false);
  const [isCancelModalVisible, setIsCancelModalVisible] = useState(false);

  const isRequestForMe = (request) => {
    return request.idTiendaDestino === branchFiSucursalId.toString();
  };

  const isRequestFromMe = (request) => {
    return request.idTiendaSolicitud === branchFiSucursalId.toString();
  };

  const shouldApproveBeCalled = (request) => {
    return isRequestForMe(request) && request.idEstado === EstadoSolicitud.PENDIENTE_APROBACION;
  };

  const shouldCancelLoanBeCalled = (request) => {
    return isRequestForMe(request) && request.idEstado === EstadoSolicitud.APROBADO;
  };

  const shouldCancelRequestBeCalled = (request) => {
    return isRequestFromMe(request) && request.idEstado === EstadoSolicitud.PENDIENTE_APROBACION;
  };

  const shouldDeclineBeCalled = (request) => {
    return isRequestForMe(request) && request.idEstado === EstadoSolicitud.PENDIENTE_APROBACION;
  };

  const onChange = (dateString) => {
    setDate({
      startDate: dateString[0],
      endDate: dateString[1],
    });
  };

  const [date, setDate] = useState({
    startDate: "",
    endDate: "",
  });

  const flagsConsult = {
    isInactive: false,
    message: "Elige rango de fecha.",
  };
  const disabledDate = (current) => {
    const today = dayjs().endOf("day");
    // Calcular la fecha mínima restando 52 semanas
    let minDate = dayjs().subtract(52, "week").startOf("day");
    // Si minDate no es lunes
    if (minDate.day() !== 1) {
      minDate = minDate.subtract((minDate.day() + 6) % 7, "day"); // Mover al lunes anterior
    }
    return current && (current > today || current < minDate);
  };
  const handleReload = async (date, isRefresh = false) => {
    if (isRefresh) {
      onChange(["", ""]);
    }
    try {
      setIsLoading(true);
      await fetchSolicitudes();
    } catch (error) {
      console.error("Error al obtener los datos:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const showModal = (record) => {
    setSelectedSolicitud(record);
    setIsModalVisible(true);
  };

  const showCancelModal = (record) => {
    setSelectedSolicitud(record);
    setIsCancelModalVisible(true);
  };

  const showOkModal = (record) => {
    console.log(record);
    setSelectedSolicitud(record);
    setIsModalOkVisible(true);
  };

  const handleVolver = () => {
    cancelAndDeclineForm.resetFields();
    setIsModalVisible(false);
    setIsModalOkVisible(false);
    setIsCancelModalVisible(false);
    setSelectedSolicitud(null);
  };

  const handleDecline = () => {
    setIsLoading(true);
    const onFailure = (error) => {
      console.log(error);
      setIsLoading(false);
    };
    const onSuccess = () => {
      setIsLoading(false);
      setIsModalVisible(false);
      cancelAndDeclineForm.resetFields();
      fetchSolicitudes();
    };
    cancelAndDeclineForm.validateFields().then(() => {
      UpdateFetchPersonal({
        idSolicitud: selectedSolicitud.idSolicitud,
        idSolicitudEstado: EstadoSolicitud.RECHAZADO,
        idSolicitudUsuario: employeeId,
        solicitudComentario: cancelAndDeclineForm.getFieldValue("reason"),
      })
        .then(onSuccess)
        .catch(onFailure);
    });
  };

  const handleCancel = (event) => {
    event.preventDefault();
    setIsLoading(true);
    const onFailure = (error) => {
      console.log(error);
      setIsLoading(false);
    };
    const onSuccess = () => {
      setIsLoading(false);
      setIsModalVisible(false);
      cancelAndDeclineForm.resetFields();
      fetchSolicitudes();
    };
    cancelAndDeclineForm.validateFields().then(() => {
      UpdateFetchPersonal({
        idSolicitud: selectedSolicitud.idSolicitud,
        idSolicitudEstado: EstadoSolicitud.CANCELADO,
        idSolicitudUsuario: employeeId,
        solicitudComentario: cancelAndDeclineForm.getFieldValue("reason"),
      })
        .then(onSuccess)
        .catch(onFailure);
    });
  };

  const handleAsignar = () => {
    setIsLoading(true);
    const onFailure = (error) => {
      console.log(error);
      setIsLoading(false);
    };
    const onSuccess = () => {
      setIsLoading(false);
      setIsModalOkVisible(false);
      cancelAndDeclineForm.resetFields();
      fetchSolicitudes();
    };
    UpdateFetchPersonal({
      idSolicitud: selectedSolicitud.idSolicitud,
      idSolicitudEstado: 2,
      idSolicitudUsuario: employeeId,
      solicitudComentario: "",
      idEmpleado: empleadoAsignado,
    })
      .then(onSuccess)
      .catch(onFailure);
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const succesButtonStyle = {
    color: "white",
    backgroundColor: "#4DBF6C",
    borderColor: "#4DBF6C",
    minWidth: "150px",
    borderRadius: "20px",
    minHeight: "38px",
  };
  const fetchSolicitudes = async () => {
    setIsLoading(true);
    const onFailure = (error) => {
      console.log(error);
      setIsLoading(false);
    };
    const onSuccess = ({ data }) => {
      setSolicitudes(data);
      setSolicitudesTodas(data);
      setIsLoading(false);
    };
    GetFetchPersonal({
      idSolicitante: "",
      idPrestador: "",
      idEmpleado: "",
      idSolicitud: "",
    })
      .then(onSuccess)
      .catch(onFailure);
  };

  useEffect(() => {
    if (solicitudes.length === 0) fetchSolicitudes();
  }, []);

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Buscar`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Buscar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Cerrar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const showPendientes = () => {
    const pendientes = solicitudesTodas.filter((s) => s.idEstado === "1");
    setSolicitudes(pendientes);
  };

  const showTodas = () => {
    setSolicitudes(solicitudesTodas);
  };

  const showReceived = () => {
    const pendientes = solicitudesTodas.filter(
      (s) => s.idTiendaDestino === branchFiSucursalId.toString()
    );
    setSolicitudes(pendientes);
  };

  const filterByDate = () => {
    if (date.startDate === "" && date.endDate === "") {
      setSolicitudes(solicitudesTodas);
      return;
    }
    const filtered = solicitudesTodas.filter(
      (s) => s.fechaInicial >= date.startDate && s.fechaInicial <= date.endDate
    );
    setSolicitudes(filtered);
  };

  const showSend = () => {
    const pendientes = solicitudesTodas.filter(
      (s) => s.idTiendaSolicitud === branchFiSucursalId.toString()
    );
    setSolicitudes(pendientes);
  };

  const navigateToFuncionSeleccionTienda = () => {
    navigate(`/tienda`);
  };

  const columns = [
    {
      title: "Colaborador",
      dataIndex: "nombreEmpleado",
      key: "nombreEmpleado",
      sorter: (a, b) => a.nombreEmpleado.length - b.nombreEmpleado.length,
      ...getColumnSearchProps("nombreEmpleado"),
      render: (_, data) => {
        if (data.estado === "Aprobado") {
          return (
            <>
              <div style={{ color: "#1484b3" }}>
                <strong>{data.nombreEmpleado}</strong>
              </div>
              Nº Colaborador: {data.idEmpleado}
            </>
          );
        }
        return <>Pendiente de asignar</>;
      },
    },
    {
      title: "Estatus",
      dataIndex: "estado",
      key: "estado",
      width: 200,
      sorter: (a, b) => a.estado.length - b.estado.length,
      ...getColumnSearchProps("estado"),
    },
    {
      title: "Tienda Solicita",
      dataIndex: "tiendaSolicita",
      key: "tiendaSolicita",
      sorter: (a, b) => a.tiendaSolicita.length - b.tiendaSolicita.length,
      ...getColumnSearchProps("tiendaSolicita"),
    },
    {
      title: "Tienda Destino",
      dataIndex: "tiendaDestino",
      key: "tiendaDestino",
      sorter: (a, b) => a.tiendaDestino.length - b.tiendaDestino.length,
      ...getColumnSearchProps("tiendaDestino"),
    },
    {
      title: "Fecha Asignada",
      dataIndex: "fechaInicial",
      key: "fechaInicial",
      width: 190,
      sorter: (a, b) => a.fechaInicial.length - b.fechaInicial.length,
      ...getColumnSearchProps("fechaInicial"),
    },
    {
      title: "Horario",
      dataIndex: "hora",
      key: "hora",
      width: 120,
      sorter: (a, b) => a.hora.length - b.hora.length,
      ...getColumnSearchProps("hora"),
    },
    {
      title: "Acción",
      dataIndex: "accion",
      key: "accion",
      render: (_, record) => {
        return (
          <>
            {shouldApproveBeCalled(record) && (
              <Button
                style={{
                  backgroundColor:
                    record.estado === "Pendiente de Aprobacion" ? "#4dbf6c" : "lightgrey",
                  borderRadius: 20,
                  color: "#FFF",
                  fontWeight: "500",
                  marginRight: 10,
                }}
                onClick={() => showOkModal(record)}
                type="primary"
                disabled={record.estado !== "Pendiente de Aprobacion"}
              >
                Aprobar
              </Button>
            )}
            {shouldCancelRequestBeCalled(record) && (
              <Button
                style={{
                  backgroundColor: "#c7002e",
                  borderRadius: 20,
                  color: "#FFF",
                  fontWeight: "500",
                  marginRight: 10,
                }}
                onClick={() => {
                  showCancelModal(record);
                }}
                type="primary"
                disabled={record.estado !== "Pendiente de Aprobacion"}
              >
                Cancelar solicitud
              </Button>
            )}
            {shouldCancelLoanBeCalled(record) && (
              <Button
                style={{
                  backgroundColor: "#c7002e",
                  borderRadius: 20,
                  color: "#FFF",
                  fontWeight: "500",
                  marginRight: 10,
                }}
                onClick={() => {
                  showCancelModal(record);
                }}
                type="primary"
                disabled={record.estado !== "Pendiente de Aprobacion"}
              >
                Cancelar préstamo
              </Button>
            )}
            {shouldDeclineBeCalled(record) && (
              <Button
                style={{
                  backgroundColor: "#c7002e",
                  borderRadius: 20,
                  color: "#FFF",
                  fontWeight: "500",
                  marginRight: 10,
                }}
                onClick={() => {
                  showModal(record);
                }}
                type="primary"
                disabled={record.estado !== "Pendiente de Aprobacion"}
              >
                No aprobar
              </Button>
            )}
          </>
        );
      },
    },
  ];

  if (isLoading) return <Spin />;
  return (
    <>
      <Row justify="center" className="mt-3">
        <Col span={22} al>
          <Space style={{ display: "flex" }}>
            <div style={{ color: "#003a53", fontSize: 16, fontWeight: "bold" }}>
              Verifica el estado de tus solicitudes
            </div>
          </Space>
        </Col>
      </Row>
      <Row justify="center">
        <Col xs={22} md={22}>
          <Row justify="space-between" align="middle" className="my-3 ">
            <Space
              direction="horizontal"
              className="responsive-buttons"
              style={{ display: "flex" }}
            >
              <Tooltip title="Recargar">
                <Button
                  type="default"
                  onClick={() => {
                    handleReload(date, true);
                  }}
                  isLoading={isLoading}
                >
                  {isLoading ? null : (
                    <RedoOutlined
                      style={{
                        fontSize: "20px",
                      }}
                    />
                  )}
                </Button>
              </Tooltip>
              <RangePicker
                value={
                  date.startDate && date.endDate
                    ? [dayjs(date.startDate), dayjs(date.endDate)]
                    : null
                }
                placeholder={["Fecha inicial", "Fecha final"]}
                onChange={(dates, dateString) => {
                  onChange(dateString);
                }}
                allowClear={false}
                disabledDate={disabledDate}
              />
              <Tooltip title={flagsConsult.message}>
                <Button
                  className={"button-styles-add-element"}
                  type="primary"
                  onClick={() => {
                    filterByDate();
                  }}
                  disabled={flagsConsult.isInactive || isLoading}
                  isLoading={isLoading}
                >
                  Consultar
                </Button>
              </Tooltip>
            </Space>
            <Space direction="horizontal">
              <Button
                onClick={showTodas}
                style={{
                  backgroundColor: "white",
                  borderRadius: 20,
                  color: "#000",
                  fontWeight: "100",
                }}
              >
                Todas
              </Button>
              <Button
                onClick={showReceived}
                style={{
                  backgroundColor: "white",
                  borderRadius: 20,
                  color: "#000",
                  fontWeight: "100",
                }}
                icon={<ArrowDownOutlined />}
              >
                Recibidas
              </Button>
              <Button
                onClick={showSend}
                style={{
                  backgroundColor: "white",
                  borderRadius: 20,
                  color: "#000",
                  fontWeight: "100",
                }}
                icon={<ArrowUpOutlined />}
              >
                Enviadas
              </Button>
              <Button
                onClick={showPendientes}
                style={{
                  backgroundColor: "white",
                  borderRadius: 20,
                  color: "#000",
                  fontWeight: "100",
                }}
                icon={
                  <Badge
                    count={
                      solicitudesTodas.filter((s) => s.estado === "Pendiente de Aprobacion").length
                    }
                  ></Badge>
                }
              >
                Pendientes
              </Button>
              <Button
                onClick={navigateToFuncionSeleccionTienda}
                className="button-styles-add-element"
                type="primary"
              >
                Agregar Solicitud
              </Button>
            </Space>
          </Row>
          <Table
            dataSource={solicitudes}
            columns={columns}
            loading={isLoading}
            scroll={{ x: 1400, y: 600 }}
            showSorterTooltip={{
              target: "sorter-icon",
            }}
            bordered
          />
        </Col>
      </Row>
      <Modal
        title="Solicitud no aprobada"
        open={isModalVisible}
        onCancel={handleVolver}
        footer={null}
      >
        <Form form={cancelAndDeclineForm}>
          <Form.Item name="reason">
            <TextArea rows={4} placeholder="Especifique el motivo por el cual no se aprueba." />
          </Form.Item>
          <div style={{ marginTop: 16, display: "flex", justifyContent: "flex-end" }}>
            <span
              style={{
                color: "#c7002e",
                textDecoration: "underline",
                cursor: "pointer",
                fontWeight: "600",
                marginTop: 8,
                marginRight: 20,
              }}
              onClick={handleVolver}
            >
              Cancelar
            </span>
            <Button style={succesButtonStyle} onClick={handleDecline}>
              Enviar
            </Button>
          </div>
        </Form>
      </Modal>
      <Modal
        title="Solicitud cancelada"
        open={isCancelModalVisible}
        onCancel={handleVolver}
        footer={null}
      >
        <Form form={cancelAndDeclineForm}>
          <Form.Item name="reason">
            <TextArea rows={4} placeholder="Especifique el motivo por el cual se cancela" />
          </Form.Item>
          <div style={{ marginTop: 16, display: "flex", justifyContent: "flex-end" }}>
            <span
              style={{
                color: "#c7002e",
                textDecoration: "underline",
                cursor: "pointer",
                fontWeight: "600",
                marginTop: 8,
                marginRight: 20,
              }}
              onClick={handleVolver}
            >
              Cancelar
            </span>
            <Button htmlType="button" style={succesButtonStyle} onClick={handleCancel}>
              Enviar
            </Button>
          </div>
        </Form>
      </Modal>
      <Modal
        title="Seleccione recurso"
        open={isModalOkVisible}
        onCancel={handleVolver}
        footer={null}
      >
        <FormRecurso
          ceco={selectedSolicitud?.idTiendaDestino}
          setEmpleadoAsignado={setEmpleadoAsignado}
          onCancel={handleVolver}
          onSend={handleAsignar}
        />
      </Modal>
    </>
  );
};
